module.exports = __webpack_public_path__ + "static/media/touming.426f3984.png";